import { pdf } from '@react-pdf/renderer';
import { QRCodePDFOptions } from './generate-qr-code-pdf.types';
import { QRCodePDFTemplate } from '../qr-code-pdf-template/qr-code-pdf-template';

export const generateQRCodePDF = (dataUrl: string, options: QRCodePDFOptions): Promise<Blob> =>
  pdf(
    <QRCodePDFTemplate
      templateOptions={{ dataUrl, ...options }}
      isOpusCompany={options.isOpusCompany}
    />
  ).toBlob();
